export const autoClose = 20000;
